import React, {ReactElement} from "react";
import classes from './NeoHome.module.scss'

const NeoHome = (): ReactElement => {
	return (
		<div className={classes.root}>
			<h3>Historie</h3>
			<p>
				Vývoj tohoto projektu započal můj taťka v roce 2007 (v té době jsem ještě ani nevěděl co programování
				je) za účelem vyzkoušet možnosti integrovaných obvodů.
				Celý projekt je napsaný v jazyce C# a původně byl postavený na .NET Framework 3.5.
				Postupem času se začaly objevovat na českém trhu nové technologie jako jsou LED pásky, desky Arduino a
				spousty open-source projektů, které ulehčily spoustu práce.
			</p>
			<h3>Hardware</h3>
			<p>
				Během tvorby chytrého systému domácí automatizace NeoHome jsme společne s taťkou natáhli přes 1km UTP
				kabelu po celém našem domě. K systému jsou napojené teplotní čidla do každé místnosti, vypínače, světla,
				ledky, multikanálové DMX controllery, senzory pohybu a rozbití skla, senzor intenzity venkovního
				osvětlení, anemometr a spoustu dalších součástek. Velkou částí systému je také centrální jednotka pro
				výměnu vzduchu v celém domě a chytrá řídící karta na ovládání venkovních žaluzií. Všechny funkce, které
				tento systém nabízí, je možné ovládat přes dotykový panel s vlastním uživatelským rozhraním.
			</p>
			<h3>Funkce</h3>
			<h5>Automatické osvětlení</h5>
			<p>
				NeoHome je napojený na zapezpečovací systém a sbírá data ze všech čidel v domě. Jakmile nějaké čidlo
				zahlásí, že bylo aktivováno spustí se podmínkový systém, který na základě času, pozice slunce, stavu
				zabezpeční a události v kalendáři vyhodnotí které světla v domě má rozsvítit.
			</p>
			<h5>Výměna vzduchu</h5>
			<p>
				Další komponentou je potrubní systém, který vede k centrálnímu výměníku vzduchu.
				Výměna vzduchu se spouští podle přítomnosti někoho v domě (data získá ze zabezpečovacího systému) a
				délka cyklu se měří na základě kvality vzduchu a venkovní teploty.
			</p>
			<h5>Ovládání venkovních žaluzií</h5>
			<p>
				Nejnovější funkcí NeoHome je ovládání venkovních žaluzií. Tato komponenta zvládne precizní pohyb a
				naklápění žaluzií s možností pamatování si v jaké poloze jsou jednotlivé žaluzie.
				Žaluzie se ráno automaticky otevírají po vstupu do obývaku a večer opět zavírají po západu slunce.
				Systém je také schopen zjistit čas ranního budíku a pár minut předem otevřít patřičnou žaluzii pro velmi
				příjemné a přirozené probuzení.
			</p>
			<h5>Přehrávání hudby a disko osvětlení</h5>
			<p>
				Naopak funkce disko osvětlení je jednou z prvních, která se v systému objevila.
				Do aplikace je možno nahrát hudební knihovnu a pouštět hudbu přímo z aplikace.
				V případě, že z aplikace hraje nějaká hudba, je možnost zapnutí disko osvětlení a je na výběr z několika
				efektů, které jsou všechny synchronizované do rytmu právě hrající hudby.
			</p>
			<h3>Budoucnost</h3>
			<p>
				NeoHome je systém, na kterém určitě plánujeme pokračovat s rozvojem.
				Aktuální vyhlídka je aktualizace starších komponent na novější a modernější technologie.
				Mimo aktualizace starších komponent je v plánu plně tento systém integrovat na velmi znamý open-source
				projekt, který nám umožní flexibilnější ovládání systému z mobilu a jednodušší rozšíření dalšími moduly.
			</p>
			{/*<h5></h5>*/}
			{/*<p></p>*/}
		</div>
	)
}

export default NeoHome